import { render } from "./NearbyVendors.vue?vue&type=template&id=1172e021"
import script from "./NearbyVendors.vue?vue&type=script&lang=js"
export * from "./NearbyVendors.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__